(function () {
  EUGDPRController.$inject = ["API_URL", "$http", "$rootScope", "$location", "$cookies", "$timeout"];
  angular.module('calendarApp').controller('EUGDPRController', EUGDPRController);

  function EUGDPRController(API_URL, $http, $rootScope, $location, $cookies, $timeout) {
    var eugdp = this;
    eugdp.isOwner = false;
    eugdp.orgName = smooth.orgName || '';
    eugdp.companyEugdpr = smooth.forms && smooth.forms.eugdpr ? smooth.forms.eugdpr : null; // Redirect if consent already obtained

    if ($rootScope.customerInfo && $rootScope.customerInfo.eugdprconsent) {
      redirect = true;
      $location.path('/');
    }

    eugdp.doConsent = function () {
      $rootScope.throbber.show();
      var customerInfo = {
        firstname: $rootScope.customerInfo.firstname,
        lastname: $rootScope.customerInfo.lastname,
        email: $rootScope.customerInfo.email,
        eugdprconsent: true
      };
      $http.put(API_URL + '/api/v1/calendar/customer', {
        customerinfo: customerInfo,
        newtoken: true
      }).then(function (reply) {
        var response = reply.data;

        if (!response.success) {
          return $rootScope.throbber.showError(response.msg);
        }

        $rootScope.throbber.hide('EUGDPR consent updated');
        $timeout(function () {
          $location.path('/');
        }, 2000);
      }).catch(function (err) {
        console.error(err.message);
        $rootScope.throbber.showError('Sorry but an error occurred: ' + err.message);
      });
    };

    eugdp.noConsent = function () {
      $('#no-consent-modal').modal('show');
    };

    eugdp.doLogout = function () {
      $('#no-consent-modal').modal('hide');
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove(); // Delete jwt token from local storage and from cookie,
      // redirect to the login page.

      localStorage.removeItem('calendar-jwt-token');
      $cookies.remove('calendar-x-access-token');

      if (typeof $rootScope.customerInfo !== 'undefined') {
        delete $rootScope.customerInfo;
      }

      $location.path('/');
    };
  }
})();